// extracted by mini-css-extract-plugin
export default {"container":"DataPage_container__oet76"};